import React from 'react'

export const CrossSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9502 17.4996L25.7923 25.1456M10.1082 25.1456L17.9502 17.4996L10.1082 25.1456ZM25.7923 9.85352L17.9488 17.4996L25.7923 9.85352ZM17.9488 17.4996L10.1082 9.85352L17.9488 17.4996Z"
        stroke={props?.stroke || 'black'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
